import React from 'react';
import { ICommandBarItemProps, Icon, Shimmer, Stack, StackItem } from '@fluentui/react';
import { GetOrderIconByStatus } from '../OrderIcons';
import { useGetProcurementOrderCountsByStatusQuery } from '../../../store/endpoints/ProcurementEndpoints';
import Widget from '../../Common/Widgets/Widget';
import { PROCUREMENT_ORDER_STATUSES } from '../../../Constants';

interface IOrderStatusesWidgetProps {
    onClickStatus: (status: string) => void;
    vendorFilter?: string;
}

const OrderStatusesWidget: React.FC<IOrderStatusesWidgetProps> = (props) => {
    const data = useGetProcurementOrderCountsByStatusQuery({
        vendor: props.vendorFilter
    });

    const refetch = () => {
        data.refetch();
    }

    const rightCommands: ICommandBarItemProps[] = [
        {
            key: 'refresh',
            text: 'Refresh',
            iconOnly: true,
            iconProps: { iconName: 'Refresh' },
            onClick: refetch
        }
    ]

    return <Widget
        header='Orders'
        rightCommands={rightCommands}
        size='large'
        styles={{container: { height: 'auto' }}}>
        <Stack horizontal verticalAlign='center' styles={{root: {margin: '0 auto 1em auto', width: '95%'}}} tokens={{childrenGap: '1em'}} wrap>
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.PENDING} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.PENDING] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.SUBMITTED} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.SUBMITTED] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.CONFIRMED} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.CONFIRMED] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.CREDIT_HOLD} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.CREDIT_HOLD] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.IN_PROGRESS} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.IN_PROGRESS] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.BACKORDERED} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.BACKORDERED] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.PARTIAL} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.PARTIAL] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.SHIPPED} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.SHIPPED] || 0} />
            <OrderStatusDisplay status={PROCUREMENT_ORDER_STATUSES.COMPLETE} onClick={props.onClickStatus} loading={data.isFetching} count={data.data?.[PROCUREMENT_ORDER_STATUSES.COMPLETE] || 0} />
        </Stack>
    </Widget>
};

interface IOrderStatusDisplayProps {
    status: string;
    onClick: (status: string) => void;
    count: number;
    loading?: boolean;
}

const OrderStatusDisplay: React.FC<IOrderStatusDisplayProps> = (props) => {
    const isPrimaryStatus = () => {
        return [PROCUREMENT_ORDER_STATUSES.PENDING, PROCUREMENT_ORDER_STATUSES.SUBMITTED, PROCUREMENT_ORDER_STATUSES.CONFIRMED, PROCUREMENT_ORDER_STATUSES.IN_PROGRESS, PROCUREMENT_ORDER_STATUSES.COMPLETE].includes(props.status);
    }
    if (props.count === 0 && !isPrimaryStatus()) return null;
    return (<>
        <StackItem
            grow
            style={{
                cursor: 'pointer',
                userSelect: 'none',
            }}
            onClick={() => props.onClick(props.status)}
        >
            <div style={{ textAlign: 'center', borderRadius: '4px', padding: '0.5em', width: '100px', margin: '0 auto' }}>
                <div style={{margin: '0.5em'}}>{GetOrderIconByStatus(props.status, { style: { fontSize: '36px', color: '#666' } })}</div>
                <strong>{props.loading ? <Shimmer width="100%" /> : props.count}</strong><br />
                {props.status}
            </div>
        </StackItem>
        {props.status !== PROCUREMENT_ORDER_STATUSES.COMPLETE && <Icon iconName="ChevronRight" />}
    </>);
}

export default OrderStatusesWidget;